import React from 'react'
import { Formik, Form } from 'formik'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useMutation } from 'graphql-hooks'
import userSlice from 'redux/user'
import Field from 'components/atoms/Field'
import Radio from 'components/atoms/Radio'
import { Button } from 'components/atoms/Button'
import swal from 'services/swal'

const initialValues = {
  email: '',
  password: '',
  confirmPassword: '',
  name: '',
  surname: '',
  phoneNumber: '',
  accountType: '',
  avatar: '',
  specialty: '',
  city: '',
  covid: false,
  responsability: false,
  terms: false,
  privacy: false,
}

function validate(values) {
  const errors = {}

  if (!values.email) {
    errors.email = 'Inserisci una mail'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Inserisci una mail valida'
  }

  if (!values.password) {
    errors.password = 'Inserisci una password'
  } else if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Le password inserite non coincidono'
  }

  if (!values.name) {
    errors.name = 'Inserisci il tuo nome'
  }
  if (!values.surname) {
    errors.surname = 'Inserisci il tuo cognome'
  }
  if (!values.accountType) {
    errors.accountType = 'Dicci se sei un personal trainer'
  }

  if (!values.covid) {
    errors.covid = "L'accettazione è obbligatoria"
  }
  if (!values.terms) {
    errors.terms = "L'accettazione è obbligatoria"
  }
  if (!values.responsability) {
    errors.responsability = "L'accettazione è obbligatoria"
  }
  if (!values.privacy) {
    errors.privacy = "L'accettazione è obbligatoria"
  }

  if (!values.city) {
    errors.city = 'Inserisci la città'
  }

  if (values.accountType === 'trainer') {
    if (!values.phoneNumber) {
      errors.phoneNumber = 'Inserisci il tuo numero di telefono'
    }

    if (!values.specialty) {
      errors.specialty = 'Inserisci la tua specializzazione'
    }
  }

  return errors
}

const SIGNUP_MUTATION = `
mutation signup($input: UsersPermissionsRegisterInputExtended!) {
  customRegister(input: $input) {
    jwt
    user {
      id
      username
      email
      role {
        type
      }
      blocked
      confirmed
      phoneNumber
    }
  }
}
`

export default function SignupForm() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [signup] = useMutation(SIGNUP_MUTATION)

  async function onSubmit({ confirmPassword, ...values }) {
    try {
      const { name, surname } = values
      const params = {
        variables: {
          input: {
            username: name.replace(' ', '') + surname.replace(' ', ''),
            ...values,
          },
        },
      }
      const res = await signup(params)
      if (res.error) {
        throw res.error
      }
      dispatch(userSlice.actions.setUserInfo(res.data.customRegister))
      history.push('/home')
    } catch (e) {
      if (
        e?.graphQLErrors?.[0]?.extensions?.exception?.data?.message?.[0]
          ?.messages?.[0]?.id === 'Auth.form.error.email.taken'
      ) {
        swal.warn({
          text:
            "Abbiamo già questa mail nel nostro database. Recupera la password se l'hai dimenticata!",
        })
      } else {
        swal.error({
          text: 'Si è verificato un errore durante la registrazione',
        })
      }
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnMount
      validate={validate}
    >
      {({ isSubmitting, isValid, values, setFieldValue }) => (
        <Form>
          <FieldContainer>
            {/* <Field
              name="avatar"
              type="file"
              label="Avatar"
              isOptional={values.accountType === 'user'}
              onChange={(event) => {
                setFieldValue('avatar', event.currentTarget.files[0])
              }}
            /> */}

            <RadioContainer>
              <p>Sei un personal trainer?</p>
              <Radio name="accountType" id="trainer" label="Si" />
              <Radio name="accountType" id="user" label="No" />
            </RadioContainer>
            <div />

            <Field
              name="name"
              type="text"
              label="Nome"
              placeholder="Inserisci il tuo nome"
            />

            <Field
              name="surname"
              type="text"
              label="Cognome"
              placeholder="Inserisci il tuo cognome"
            />

            <Field
              name="email"
              type="email"
              label="Indirizzo Email"
              placeholder="La tua email"
            />

            <Field
              name="city"
              type="text"
              label="La tua città"
              placeholder="Bologna"
            />

            <Field
              name="password"
              type="password"
              label="Password"
              placeholder="La tua password"
            />

            <Field
              name="confirmPassword"
              type="password"
              label="Conferma Password"
              placeholder="Conferma la password scelta"
            />

            {values.accountType === 'trainer' && (
              <Field
                name="specialty"
                type="text"
                label="La tua specializzazione"
                placeholder="Cardio, Fitness..."
              />
            )}

            <Field
              name="phoneNumber"
              type="text"
              label="Telefono"
              placeholder="Il tuo telefono"
              isOptional={values.accountType === 'user'}
            />
            {values.accountType !== 'trainer' && <div />}

            <CheckWrapper>
              <Field name="privacy" type="checkbox" label="Privacy" />
              <a href="/docs/Informativa PrivacySmartGym.pdf">Leggi</a>
            </CheckWrapper>

            <CheckWrapper>
              <Field
                name="terms"
                type="checkbox"
                label="Termini e condizioni"
              />
              <a href="/docs/REGOLAMENTO SmartGym.pdf">Leggi</a>
            </CheckWrapper>

            <CheckWrapper>
              <Field
                name="responsability"
                type="checkbox"
                label="Scarico responsabilità"
              />
              <a href="/docs/Manleva.pdf">Leggi</a>
            </CheckWrapper>

            <CheckWrapper>
              <Field name="covid" type="checkbox" label="covid" />
              <a href="/docs/1.Informativa.Disposizioni.Regolamento COVID-19.pdf">
                Leggi
              </a>
            </CheckWrapper>
          </FieldContainer>

          <Footer>
            <Button
              as="input"
              type="submit"
              value="registrati"
              disabled={isSubmitting || !isValid}
            />
          </Footer>
        </Form>
      )}
    </Formik>
  )
}

const FieldContainer = styled.div`
  > * {
    margin: 0;
    margin-bottom: 24px;
  }

  @media screen and (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    > * {
      margin-bottom: 0;
    }
  }
`

const Footer = styled.footer`
  margin-top: 24px;
  @media screen and (max-width: 1023px) {
    input {
      width: 100%;
    }
  }
  @media screen and (min-width: 1024px) {
    margin-top: 32px;
  }
`

const RadioContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`

const CheckWrapper = styled.div`
  display: flex;
  align-items: center;

  & > a {
    text-decoration: underline;
    color: #fe7e36;
    margin-left: 10px;
  }
`
